export const chooseMonthTitle = "Choose the month your Home insurance is up for renewal";
export const chooseMonthTitleInfo = "We will remind you before it's due.";
export const renewalMonth = "Renewal month";
export const readPolicy = "For full explanation of all these terms and limits, please read the";
export const policyBooklet = "Policy Booklet";
export const continueBtn = "Continue";
export const onTouch = "Great! We'll be in touch.";
export const getNow = "Or, get it done now!";
export const xSellNowQn = "Would you like to do your Home Insurance quote now?";
export const getQuoteNowBtn = "Or, get it done now!";
export const closeBtn = "Close";
export const doQuickQuestionNowBtn = "Answer some quick questions";
export const doQuoteNowBtn = "Do full quote now";
export const policyBookletLink = 'https://www.123.ie/downloads/123StandardMotorPolicyBooklet0926.pdf';
export const optional = "Optional";
export const target = '_blank';

export const doQuickQuestion: string = "Answer some quick questions.";
export const doQuoteNow = "Do your quote now.";
export const getStartedBtn: string = "Get started";